export default "__VITE_ASSET__DkPxXw$y__";